import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconCheckCircleFill', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm4.77,5.64-5,6a1,1,0,0,1-.72.36H7a1,1,0,0,1-.71-.29l-3-3A1,1,0,1,1,4.71,7.29L6.93,9.52l4.3-5.16a1,1,0,1,1,1.54,1.28Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm5.77,6.89-6.25,7.5a1,1,0,0,1-.73.36h0A1,1,0,0,1,8,14.46L4.29,10.71A1,1,0,0,1,5.71,9.29l3,3,5.55-6.66a1,1,0,0,1,1.54,1.28Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm6.77,8.14-7.5,9a1,1,0,0,1-.73.36h0a1,1,0,0,1-.71-.29l-4.5-4.5a1,1,0,0,1,1.42-1.42L10.43,15l6.8-8.16a1,1,0,0,1,1.54,1.28Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm8.77,10.64-10,12A1,1,0,0,1,14,23h0a1,1,0,0,1-.71-.29l-6-6a1,1,0,1,1,1.42-1.42l5.22,5.23,9.3-11.16a1,1,0,0,1,1.54,1.28Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));